import Masonry from 'masonry-layout';

window.addEventListener("load", function () {

    var domElements = {
        cards: document.querySelectorAll(".teaser--border"),
        showMoreBtn: document.getElementById('show-more'),
        filters: document.querySelectorAll(".navigation-project__link"),
        masonryElement: document.querySelector('.grid-msnry--blog')
    }

    // Start values
    var active = {
        limit: 12,
        topic: (window.initial_topic !== undefined) ? window.initial_topic : "alle",
    }

    // console.log('active', active);

    // Execute filter with default values
    if(domElements.showMoreBtn) {
        applyFilter();
    }

    // Masonry grid 
    if(domElements.masonryElement) {
        var msnry = new Masonry('.grid-msnry--blog', {
            itemSelector: '.grid-msnry__item',
        });
    }

    function applyFilter() {
        // Hide all cards
        [].forEach.call(domElements.cards, function(el) {
            el.classList.add("teaser--hide");
        });

        // Show only filtered cards inside of limit
        var filteredElements = (active.topic == 'alle') ? domElements.cards : document.querySelectorAll('.teaser--border[data-topic="'+active.topic+'"]');
        var filteredArray = [...filteredElements];
        var showElements = filteredArray.slice(0, active.limit);

        [].forEach.call(showElements, function(el) {
            el.classList.remove("teaser--hide");
        });

        // Toggle show more button
        if(showElements.length < active.limit) {
            domElements.showMoreBtn.style.visibility = 'hidden';
        } else {
            domElements.showMoreBtn.style.visibility = 'visible';
        }

        // Refresh Masonry grid
        if(msnry) {
            msnry.layout();
        }
    }

    // Watch filters
    if (domElements.filters) {
        Array.prototype.forEach.call(domElements.filters, function(filter) {
            filter.addEventListener('click', filterHandler);
        });
    }

    // Watch show more
    if (domElements.showMoreBtn) {
        domElements.showMoreBtn.addEventListener('click', function(event) {
            active.limit += 12;
            applyFilter(); 
        });
    }

    function filterHandler(event) {
        event.preventDefault();
        event.stopPropagation();

        // Update navigation active class on click
        var elems = document.querySelectorAll(".navigation-project__item--active");
        [].forEach.call(elems, function(el) {
            el.classList.remove("navigation-project__item--active");
        });
        event.target.parentNode.classList.add("navigation-project__item--active");

        // Update URL
        var topic = event.target.dataset.topic;

        // Update active topic and reset limit
        active.topic = topic;
        active.limit = 12;

        applyFilter();
    }
}, false);